import React from "react";
import classNames from "classnames";

import './Alert.scss'

type Props = {
  type: 'blue' | 'error';
  label?: string;
  subtitle?: string
  small?: boolean
}

const Alert = ({type = 'blue', label, subtitle, small = false}:Props) => {
  return (
    <div className={classNames("alert", {'alert--small': small,'alert--blue': type === 'blue', 'alert--error': type === 'error'})}>
      <b>{label}</b>
      <span>{subtitle}</span>
    </div>
  )
};

export default Alert;
